import Vue from 'vue'
import VueRouter from 'vue-router'
import { Message } from 'element-ui'
import { getProfile } from '@/api/systemData'
import store from '@/store'
import {getToken,setToken,removeToken,getMenu} from '@/utils/auth'


const Main = () => import('../layout/Main')

//登录页面
const Login = () => import('../views/login/index.vue')


Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routerAPI = [
  { path: '/login',component: Login },
  
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/index',
    name: 'Index',
    component: Main,
    redirect: '/Home',
    children: [
      {
        path: '/Home',
        name: 'Home',
        component: ()=>import('@/views/home/index.vue'),
        meta: {
          title: '总览'
        }
      },
      
    ]
  }
]
// this.$router.push({ name: 路由的名字 })
const router = new VueRouter({
  routes: routerAPI,
  mode: 'hash'   // 从 'history' 改为 'hash'
})

router.beforeEach((to, from, next) => {
  const token = getToken();

  // 获取菜单数据
  let response = [];
  const menu = JSON.parse(sessionStorage.getItem('menus') || '[]');
  if (menu.length > 0) {
    // 过滤掉 Home 和根路径，使用 && 而不是 ||
    let menuList = menu.filter(item => item.path !== '/Home' && item.path !== '/');
    response = menuList;
  }
  // response = [
  //   {
  //       path: '/systemSource/admin',
  //       name: 'user',
  //       component: ()=>import('@/views/systemSource/admin/index.vue'),
  //       meta: {
  //         title: '人员管理'
  //       }
  //     },
  //     {
  //       path: '/systemSource/userInfo',
  //       name: 'userInfo',
  //       component: ()=>import('@/views/systemSource/userInfo/index.vue'),
  //       meta: {
  //         title: '用户详情'
  //       }
  //     },
  //     {
  //       path: '/systemSource/role',
  //       name: 'role',
  //       component: ()=>import('@/views/systemSource/role/index.vue'),
  //       meta: {
  //         title: '角色管理'
  //       }
  //     },
  //     {
  //       path: '/systemSource/permission',
  //       name: 'permission',
  //       component: ()=>import('@/views/systemSource/permission/index.vue'),
  //       meta: {
  //         title: '权限管理'
  //       }
  //     },
  //     {
  //       path: '/systemSource/dict',
  //       name: 'dict',
  //       component: ()=>import('@/views/systemSource/dict/index.vue'),
  //       meta: {
  //         title: '字典管理'
  //       }
  //     },
  // ]

  // 获取到菜单列表 -- 侧边栏展示
  // 检查是否需要加载动态路由（每次都检查，确保路由存在）
  if (response != null && response.length > 0) {
    // 检查当前路由是否已经存在
    const currentRouteExists = router.getRoutes().some(r => r.path === to.path);
    
    if (!currentRouteExists) {
      let vueObj = new Vue({
        data: {
          response:response
        }
      });
      response = vueObj.response;
      for(let i = 0 ;i<response.length ;i++){
        response[i].component = () => import(`@/views${ response[i].path}/index.vue`);
      }

      // 找到父路由
      const indexRoute = router.options.routes.find(route => route.name === 'Index');
      if (indexRoute && Array.isArray(indexRoute.children)) {
        response.forEach(route => {
          const existingRoute = router.getRoutes().find(r => r.path === route.path)
          if (!existingRoute) {
            router.addRoute('Index', route);
          }
        });
      }
      // 重新导航到目标路由，确保路由已注册
      next({ ...to, replace: true })
      return;  // 防止继续执行后面的 next()
    }
  }

  // 从state中获取到路由信息
  if( token != "" && typeof token != "undefined"){
    next(); 
    console.log('menu-Show', router.getRoutes())
  } else {
    if(to.path == '/login'){
      next(); 
    } else {
      next('/login'); 
    }
  }
});
export default router
